// Minimal button spacing enforcer - Product pages only
document.addEventListener('DOMContentLoaded', function() {
  function fixButtonSpacing() {
    const containers = document.querySelectorAll('.product-form__buttons, .buy-buttons');
    containers.forEach(container => {
      Array.from(container.children).forEach((btn, i) => {
        btn.style.marginTop = i === 0 ? '0px' : '12px';
        btn.style.marginBottom = '0px';
      });
    });
  }
  
  // Fix immediately
  fixButtonSpacing();
  
  // Watch for dynamic changes with MutationObserver (more efficient than setInterval)
  const observer = new MutationObserver(fixButtonSpacing);
  
  const containers = document.querySelectorAll('.product-form__buttons, .buy-buttons');
  containers.forEach(container => {
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  });
  
  // Also watch for new containers being added
  const bodyObserver = new MutationObserver(() => {
    const newContainers = document.querySelectorAll('.product-form__buttons, .buy-buttons');
    newContainers.forEach(container => {
      if (!container.hasAttribute('data-spacing-observed')) {
        container.setAttribute('data-spacing-observed', 'true');
        observer.observe(container, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
        fixButtonSpacing();
      }
    });
  });
  
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});
